var cov_l1djnf049 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Icon.tsx",
      hash = "a45eef425a0c98e144fb47114ca63be53782802c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Icon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 56
        },
        end: {
          line: 13,
          column: 66
        }
      },
      "2": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 18,
          column: 5
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 74
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 12
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 52
          },
          end: {
            line: 16,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 52
          },
          end: {
            line: 16,
            column: 60
          }
        }, {
          start: {
            line: 16,
            column: 64
          },
          end: {
            line: 16,
            column: 74
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 15
          },
          end: {
            line: 17,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 26
          },
          end: {
            line: 17,
            column: 35
          }
        }, {
          start: {
            line: 17,
            column: 38
          },
          end: {
            line: 17,
            column: 45
          }
        }],
        line: 17
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { createElement, PureComponent } from 'react';
import icons from '../icons';
import { datepickerClass } from './styles';
var DefaultValue = (cov_l1djnf049.s[0]++, {
  tag: 'span'
});

var Icon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  var _super = _createSuper2(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      cov_l1djnf049.f[0]++;

      var _ref = (cov_l1djnf049.s[1]++, this.props),
          className = _ref.className,
          name = _ref.name,
          onClick = _ref.onClick,
          tag = _ref.tag,
          disabled = _ref.disabled;

      var newProps = (cov_l1djnf049.s[2]++, {
        className: datepickerClass(className, 'icon', (cov_l1djnf049.b[0][0]++, disabled) && (cov_l1djnf049.b[0][1]++, 'disabled')),
        onClick: disabled ? (cov_l1djnf049.b[1][0]++, undefined) : (cov_l1djnf049.b[1][1]++, onClick)
      });
      cov_l1djnf049.s[3]++;
      return (
        /*#__PURE__*/
        createElement(tag, newProps, icons[name])
      );
    }
  }]);

  return Icon;
}(PureComponent);

Icon.defaultProps = DefaultValue;
export default Icon;